
// package imports
import { Col, Row } from "react-bootstrap"
// project imports
import "./bonus-life-assured-details-card.css"
import BonusProposerDetailsCard from "../bonus-proposer-details-card/BonusProposerDetailsCard"

const BonusLifeAssuredDetailsCard = (props) => {
    const { LADetails } = props
    return (
        <>
            {LADetails.all_journey_list.map((item, index) => (
                <>
                    <Row className="bonus-card mb-4 mx-0">
                        <Col className=" col-12 col-md-2 la-card-bonus font-size-13 mb-3 mb-md-0">
                            <div>
                                <p className='font-size-12 mb-0 text-primary'>Life Assured Name</p>
                                <div className="border my-1 w-100 font-size-13 text-center">{item.la_name} </div>
                            </div>
                        </Col>

                        <Col className="col-12 col-md-10">
                            {item.journey_list.length > 1 ?
                                item.journey_list.map((data, index) => {
                                    return (
                                        <>
                                            <div className={`bonus-child`}>
                                                <BonusProposerDetailsCard
                                                    proposerData={data}
                                                />
                                                {item.journey_list.length !== index + 1 && (
                                                    <hr className='my-2 hr-bonus' ></hr>
                                                )}
                                            </div>
                                        </>
                                    )
                                })
                                :
                                <div className={`bonus-child`}>
                                    <BonusProposerDetailsCard
                                        proposerData={item.journey_list[0]}
                                    />
                                </div>
                            }
                        </Col>
                       
                    </Row>
                 
                        
                 
                </>
            ))}
        </>
    )
}
export default BonusLifeAssuredDetailsCard;
